import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { path } from 'ramda'

import { api } from 'app/api'
import { POST_IDENTIFIERS_PREPAID_APPEND } from 'app/common/api/requests/cabinet/identifiers/prepaid/append'
import usePopup from 'app/common/hooks/usePopup'
import Person from 'app/common/classes/person'
import { IdentifierType } from 'app/common/constants/identifiers'


type Options = {
  student: Person
  onSuccess: (res: any) => void
  setError: (
    identifierType: IdentifierType | null,
    identifierCode: string,
    errorStatus: 'ALREADY_APPENDED' | 'PREPAID_NOT_FOUND' | 'UNKNOWN',
    flag?: 'shotVersion'
  ) => string
  resetError: () => void
}

export default function useIdentifierPrepaidAppend({
  student,
  onSuccess,
  setError,
  resetError,
}: Options) {
  const { t } = useTranslation('identifiers-next')
  const popup = usePopup()

  const append = useCallback(async (
    code: string,
    identifierType: IdentifierType | null,
  ): Promise<boolean> => {
    resetError()

    const res = await api.request(POST_IDENTIFIERS_PREPAID_APPEND, {
      error: (err: Error) => {
        const errorStatus: (
          | 'ALREADY_APPENDED'
          | 'PREPAID_NOT_FOUND'
          | 'UNKNOWN'
        ) = path(['response', 'data', 'symbol'], err) || 'UNKNOWN'
        const errorText = setError(identifierType, code, errorStatus, 'shotVersion')
        return errorText
      },

      params: {
        student_id: student.ID,
        number: code.replace(/\s/g, ''),
      },
    })

    if (res) {
      onSuccess(res)
      popup(t('identifier_entering_submit_success', 'Идентификатор успешно добавлен'))
      return true
    }
    return false
  }, [student, t, onSuccess, popup, setError, resetError])

  return { append }
}
